import {injectable} from "inversify";
import {Player} from "@/modules/team/entity";
import LineupSkillCalculator from "@/modules/team/services/LineupSkillCalculator";

@injectable()
export default class EffectiveLineupSkillCalculator extends LineupSkillCalculator {
  public getPlayersSkill(player: Player) {
    const formSkill = (player.form - 50) / 100 * player.skill * this.configRepository.get('players.form.effectOnSkillFactor');
    const energySkill = player.skill * this.configRepository.get('players.energy.effectOnSkillFactory')(player);

    return Math.max(1, player.skill + formSkill + energySkill);
  }
}
